module.exports = __webpack_public_path__ + "img/white_shapes.846fa246.png";